<template>
  <div class="item-img" :class="[loaded ? 'is-loaded' : '']">
    <transition name="animation-fade">
      <img class="item-img__img" v-show="loaded" ref="img" :src="src" :alt="alt" @load="loaded()">
    </transition>
  </div>
</template>



<script>
import { mapState } from 'vuex'

export default {
  props: {
    src: String,
    alt: String,
  },
  computed: {
    ...mapState({
      windowWidth: state => state.window.width,
    })
  },
  data() {
    return {
      load: false,
      clientHeight: null,
    }
  },
  watch: {
    windowWidth(val) {
      this.windowResize()
    },
  },
  methods: {
    loaded() {
      this.load = true
      this.clientHeight = this.$refs.img.clientHeight
      this.$emit('height', this.clientHeight)
    },
    windowResize() {
      let timeoutId

      window.addEventListener('resize', () => {
        clearTimeout(timeoutId)
        timeoutId = setTimeout(() => {
          this.clientHeight = this.$refs.img.clientHeight
          this.$emit('height', this.clientHeight)
        }, 300)
      })
    },
  }
}
</script>



<style lang="scss">
.item-img {
  transition: 0.3s ease-out;
  height: 150px;
  &.is-loaded {
    height: auto;
  }
  &__img {
    width: 100%;
  }
}
</style>
